import { render, staticRenderFns } from "./createDepositchannel.vue?vue&type=template&id=bb79af0e&scoped=true"
import script from "./createDepositchannel.vue?vue&type=script&lang=js"
export * from "./createDepositchannel.vue?vue&type=script&lang=js"
import style0 from "./createDepositchannel.vue?vue&type=style&index=0&id=bb79af0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb79af0e",
  null
  
)

export default component.exports